import { APP_BASE_HREF, CommonModule, HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApContentModule } from '@ap/content';
import { ApPegaModule, provideAppCore } from '@ap/pega';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces BASE_HREF
export const baseHref: string = BASE_HREF;

@NgModule({
    imports: [ApContentModule, ApPegaModule, BrowserAnimationsModule, CommonModule],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: baseHref
        },
        Location,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        ...provideAppCore({ standalone: true })
    ]
})
export class ProductOpenenModule {}
